export const isSecondStepNext = (nextStep, regType) => {
  const regTypeIsAllOrPersonalInfo = regType === 'all' || regType === 'personalInfo';
  const nextStepIsSecond = nextStep === 2;

  return regTypeIsAllOrPersonalInfo && nextStepIsSecond;
};

export const checkNextStepAndRegTypeAreInList = ({nextStep, regType, stepList, regTypeList}) => {
  const regTypeInList = regTypeList.indexOf(regType) >= 0;
  const nextStepInList = stepList.indexOf(nextStep) >= 0;

  return regTypeInList && nextStepInList;
};

export const checkNextStepForDuplicateFirstNameValue = (nextStep, regType) => {
  const stepList = [2, 6];
  const regTypeList = ['all', 'personalInfo', 'contract'];

  return checkNextStepAndRegTypeAreInList({nextStep, regType, stepList, regTypeList});
};

export const getUrlForStepSubmit = step => {
  if (step === 6) {
    return '/regContract/submitStep6'
  }
  if ((step > 6 && step < 10) || step === 18) {
    return `/regBituahLeumi/submitStep${step}`;
  }
  if (step >= 10 && step < 16) {
    return `/regIncomeTax/submitStep${step}`;
  }
  return `/regGeneral/submitStep${step}`;
};
